function formatMoney(cents) {
  // Uses Shopify’s built-in formatting if available
  if (window.Shopify && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, window.theme?.moneyFormat || "{{amount_with_comma_separator}} €");
  }
  // Fallback
  const value = (cents / 100).toFixed(2).replace(".", ",");
  return `€${value}`;
}

function updateFreeShippingMessage(scope = document) {
  const el = scope.querySelector(".cart-free-shipping");
  if (!el) return;

  const threshold = parseInt(el.dataset.freeShippingThreshold, 10);
  const total = parseInt(el.dataset.cartTotal, 10);

  const textEl = el.querySelector(".cart-free-shipping__text");
  if (!textEl || Number.isNaN(threshold) || Number.isNaN(total)) return;

  const remaining = threshold - total;

  if (remaining > 0) {
    textEl.textContent = `You’re ${formatMoney(remaining)} away from free shipping.`;
  } else {
    textEl.textContent = `Free shipping activated.`;
  }
}

// Initial load
document.addEventListener("DOMContentLoaded", () => {
  updateFreeShippingMessage(document);
});

// Update when cart updates (Dawn uses cart events + sections rendering)
document.addEventListener("cart:refresh", () => updateFreeShippingMessage(document));
document.addEventListener("cart:updated", () => updateFreeShippingMessage(document));

// Fallback: listen to fetch updates Dawn triggers
document.addEventListener("change", (e) => {
  if (e.target && (e.target.name === "updates[]" || e.target.closest("cart-items") || e.target.closest("cart-drawer"))) {
    // Give Shopify time to re-render sections
    setTimeout(() => updateFreeShippingMessage(document), 300);
  }
});

